import { render, staticRenderFns } from "./bank-transfer-sms.vue?vue&type=template&id=a56a904e&scoped=true&"
import script from "./bank-transfer-sms.vue?vue&type=script&lang=js&"
export * from "./bank-transfer-sms.vue?vue&type=script&lang=js&"
import style0 from "./bank-transfer-sms.vue?vue&type=style&index=0&id=a56a904e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56a904e",
  null
  
)

export default component.exports